import { reducer as form } from 'redux-form';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import app from './containers/App/reducer';
import auth from './containers/Login/reducer';
import orders from './containers/Orders/reducer';

export const history = createBrowserHistory();

export const reducersList = {
  form,
  router: connectRouter(history),
  app,
  auth,
  orders,
};

const reducers = combineReducers(reducersList);

export default reducers;
